/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React, { useRef } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setAuth, setUser } from '../../redux/actions';
import { onAuthUIStateChange, AuthState } from '@aws-amplify/ui-components';
import checkForceAuth from './helpers/checkForceAuth';
import checkValidityCookiesTokens from './helpers/checkValidityCookiesTokens';
import handleAuthUIStateChange from './helpers/handleAuthStateChange';
import handleIdpLogin from './helpers/handleIdpLogin';
import SignInContainer from './signInContainer';
import { useLocation } from 'react-router-dom';
import { verifyRefreshToken } from './helpers/isValidSession';
import redirectHelper from './helpers/redirectHelper';
import Cookies from "js-cookie";
import { I18n } from 'aws-amplify';
import { AmplifySignOut } from '@aws-amplify/ui-react';
import { Button, makeStyles } from '@material-ui/core';
import forceLogout from './helpers/forceLogout';
import { Branding } from '../../branding';
import * as Sentry from "@sentry/react";

const mapStateToProps = (state) => {
	return {
		auth: state.app.auth,
		user: state.user,
	}
};

const useStyles = makeStyles((theme) => ({
	button: {
		width: 200,
		backgroundColor: Branding.accent,
		color: 'white',
		fontWeight: 'bold',
		'&:hover': {
			backgroundColor: Branding.accent,
			opacity: Branding.opacityHover,
		}
	}
}));

const LandingPage = (props) => {
	const [authState, setAuthState] = React.useState();
	const [loaded, setLoaded] = React.useState(false);
	const [isAutlogin, setIsAutoLogin] = React.useState(false);
	const classes = useStyles();

	const propSetUser = props.setUser;
	const propSetAuth = props.setAuth;
	const location = useLocation();
	const refAutologin = useRef();
	handleIdpLogin.bind(this);

	async function checkUserData() {
		try {
			if (new URLSearchParams(location.search)?.get("fromWindowMessages") == "true") {
				console.log(`[SSO] Skip checks because fromWindowMessages is active`)
			} else {
				console.log(`[SSO] checkUserData...`);
				await checkValidityCookiesTokens();
				await checkForceAuth();

				if (!!!authState && Cookies.get('refresh_token')) {
					refAutologin.current = true;
					console.log(`Dentro autologin`)
					setIsAutoLogin(true)
					const res = await verifyRefreshToken()
					if (!!res?.success) {
						handleAuthUIStateChange(AuthState.SignedIn);
					}
				}

			}
		} catch (error) {
			//Silent check, go forward
			Sentry.addBreadcrumb({
				category: "auth",
				message: "The user is not authenticated",
				level: "info",
			});
		}

		onAuthUIStateChange((nextAuthState, authData) => {
			handleAuthUIStateChange(nextAuthState);
			setAuthState(nextAuthState);

			if (nextAuthState === AuthState.ConfirmSignUp) {
				if (authData && authData.username && authData.signUpAttrs.attributes) {
					let user = {
						id: '',
						username: authData.username,
						attributes: authData.signUpAttrs.attributes
					}
					propSetUser(user);
				}
			}

			if (nextAuthState === AuthState.SignedIn) {
				propSetAuth(true);

				if (authData && authData.username && authData.attributes) {
					let user = {
						id: authData.attributes.sub,
						username: authData.username,
						attributes: authData.attributes
					}
					propSetUser(user);
				}
			}
			setLoaded(true);
		});
	}

	React.useEffect(() => {
		if (!refAutologin.current) {
			checkUserData()
		}
	}, [propSetAuth, propSetUser]);

	return isAutlogin ? <div style={{ padding: 25 }}>
		<p style={{ marginBottom: 25 }}>{I18n.get("LANDING_PAGE_WAIT_REDIRECTION")}</p>
	</div> : (
		(authState === AuthState.SignedIn && loaded && props.user && props.user.username)
			? <Redirect to='/dashboard' />
			: <SignInContainer authState={location?.pathname?.includes("reset-password") ? AuthState.ForgotPassword : location?.pathname?.includes("signup") ? AuthState.SignUp : authState} loaded={loaded} />
	);
};

export default withRouter(connect(mapStateToProps, { setAuth, setUser })(LandingPage));
